<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">Edit Profile</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <form class="col-md-6" id="payment-data">
              <div class="form-group text-center">
                <span class="m-topbar__userpi">
                  <img
                    :src="profileImageURL"
                    class="m--img-rounded m--marginless m--img-centered"
                    width="100px"
                    alt="webco lms"
                  />
                </span>
              </div>
              <div class="form-group">
                <label for="first_name">First Name</label>
                <input
                  type="text"
                  v-model="studentDetails.first_name"
                  name="first_name"
                  class="form-control"
                  id="first_name"
                />
              </div>
              <span
                id="first_name_error"
                style="display:none"
                class="text-danger"
                >This field is required</span
              >
              <div class="form-group">
                <label for="last_name">Last Name</label>
                <input
                  type="text"
                  v-model="studentDetails.last_name"
                  class="form-control"
                  id="last_name"
                  name="last_name"
                />
              </div>
              <span
                id="last_name_error"
                style="display:none"
                class="text-danger"
                >This field is required</span
              >
              <div class="form-group">
                <label for="phone">Phone</label>
                <input
                  type="text"
                  v-model="studentDetails.phone"
                  class="form-control"
                  id="phone"
                  name="phone"
                />
              </div>
              <span id="phone_error" style="display:none" class="text-danger"
                >This field is required</span
              >
              <div class="form-group">
                <label for="dob">Date of Birth</label>
                <datetime
                  v-model="studentDetails.dob"
                  format="yyyy-MM-dd"
                  placeholder="YYYY-MM-DD"
                  input-class="form-control"
                  name="dob"
                >
                </datetime>
              </div>
              <span id="dob_error" style="display:none" class="text-danger"
                >This field is required</span
              >
              <div class="form-group">
                <label>Profile Image</label>
                <input
                  type="file"
                  name="file"
                  id="file"
                  ref="file"
                  v-on:change="handleFileUpload()"
                />
                <div class="file-message">
                  Max file size <span>2MB</span> Supported file formats:
                  <span>JPEG/PNG</span>
                </div>
              </div>
              <span id="file_error" style="display:none" class="text-danger"
                  >Please select correct file type</span
                >
            </form>
            <div class="modal-footer">
              <button class="btn btn-primary" @click="updateStudent">
                Update
              </button>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
var Cookies = require('vue-cookies')
var Config = require('../router/Config')
var $ = require('jquery')
Vue.component('datetime', Datetime)
export default {
  name: 'mypayments',
  components: {},
  props: ['getCourse'],
  data () {
    return {
      studentDetails: [],
      api_url: Config.API_URL,
      holder: 0,
      total: 0,
      dob: 0,
      file: '',
      profileImageURL: './media/users/blank-profile-picture.png'
    }
  },
  mounted () {
    this.user = Cookies.get('userDetail')
    this.getStudentDetail()
    var profileImage = Cookies.get('profileImage')
    if (profileImage !== 'null') {
      this.profileImageURL = this.api_url + '/user/' + profileImage
    }
  },
  methods: {
    getStudentDetail: function () {
      axios
        .post(
          Config.API_URL +
            '/api/fe/student/profile-detail?token=' +
            Cookies.get('accessToken'),
          {
            id: this.user.student[0].id,
            dateFormat: true
          }
        )
        .then(response => {
          this.studentDetails = response.data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateStudent: function () {
      $('#first_name_error').hide()
      $('#last_name_error').hide()
      $('#dob_error').hide()
      $('#phone_error').hide()
      $('#file_error').hide()
      if (this.studentDetails.first_name === '') {
        $('#first_name_error').show()
        return false
      }
      if (this.studentDetails.last_name === '') {
        $('#last_name_error').show()
        return false
      }
      if (this.studentDetails.dob === '') {
        $('#dob_error').show()
        return false
      }
      if (this.studentDetails.phone === '') {
        $('#phone_error').show()
        return false
      }
      // if (this.file.type !== 'image/jpeg' || this.file.type !== 'image/png') {
      //   $('#file_error').show()
      //   return false
      // }

      const formData = new FormData()
      formData.append('first_name', this.studentDetails.first_name)
      formData.append('last_name', this.studentDetails.last_name)
      formData.append('dob', this.studentDetails.dob)
      formData.append('phone', this.studentDetails.phone)
      formData.append('id', this.studentDetails.id)
      formData.append('file', this.file)
      this.axios
        .post(
          Config.API_URL +
            '/api/fe/student/profile-update' +
            '?token=' +
            Cookies.get('accessToken'),
          formData
        )
        .then(response => {
          console.log(response.data.res)
          if (response.data.res === '1') {
            Cookies.set('profileImage', response.data.user.image)
            Cookies.set('firstName', response.data.data.first_name)
            Cookies.set('lastName', response.data.data.last_name)
          }
        })
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      this.profileImageURL = URL.createObjectURL(this.file)
    }
  }
}
</script>
